module.exports = __webpack_public_path__ + "img/kq.dfe6d2ac.png";